// Accounts Side

document.addEventListener('turbo:load', function() {
  // Ensure jQuery and DataTables are loaded
  if (typeof $ === 'undefined' || !$.fn.dataTable) {
    return;
  }

  $('.dataTableFiles').dataTable( {
    "pagingType": "simple_numbers",
    "dom": 'tp',
    "aaSorting": [ ],
    "language": {
      "searchPlaceholder": "Search",
      "search": ""
    },
    "columns": [
      null,
      { "width": "20%" },
    ]
  });

  $('.dataTableFilesNoPagination').dataTable( {
    "paging": false,
    "dom": 'tp',
    "aaSorting": [ ],
    "language": {
      "searchPlaceholder": "Search",
      "search": ""
    },
    "columns": [
      null,
      { "width": "20%" },
    ]
  });

  $('.remote-data-table-accounts').each( function(index) {
    var that = $(this);
    $(this).dataTable( {
      "serverSide": true,
      "processing": true,
      "ordering": false,
      "responsive": true,
      "deferLoading": that.attr("data-total-count"),
      "ajax": {
        "url": that.attr("data-resource"),
        "type": "GET",
        "beforeSend": function(request) {
          request.setRequestHeader("X-Notefit-Account-Api-Auth-Token", connectspace_config.api_auth_token);
        }
      },
      "dom": "t<'row'r<'col-xs-1'><'col-xs-11 pull-right'p>>",
      "columns": [
        {className: "first"},
        null,
        {className: "buttons"}
      ]
    });
  });

  $('.dataTableConnection').dataTable( {
    "bLengthChange": false,
    "bPaginate" : true,
    "autoWidth": false,
    "pagingType": "simple_numbers",
    "dom": 'rtp',

    "oLanguage": {
      "oPaginate": {
        "sPrevious": "<i class='fas fa-arrow-left'/> Previous",
        "sNext": "Next <i class='fas fa-arrow-right'>"
      }
    }
  });

  $('.dataTableConnectionRequest').dataTable( {
    "bLengthChange": false,
    "bPaginate" : true,
    "autoWidth": false,
    "pagingType": "simple_numbers",
    "dom": 'rt<"clear">p',

    "oLanguage": {
      "oPaginate": {
        "sPrevious": "<i class='fas fa-arrow-left'/> Previous",
        "sNext": "Next <i class='fas fa-arrow-right'>"
      }
    }
  });

  $('.dataTable-connections-pagination-container').append($('.dataTables_paginate'));
  $('.dataTable-connection-requests-pagination-container').append($('.dataTables_paginate'));
});
